export default {"src":"/_next/static/media/effects-icon.af081a76.svg","height":24,"width":24};